var Node = require('../hierarchy/frResultNode');

/* Make a models we can just add any attributes that we are listening to for a change on it */
module.exports = Node.extend({

    defaults: function() {

        var base = _.result( Node.prototype,  'defaults' );

        return _.extend( base, {

            nodeType: 'PAGE',

            rowLevel: 1,
            parentIdAttribute: 'pageId',

            pageNumber: 0,
            isCurrentPage: false

        });

    },

    updateIsCurrentPage: function( pageNumber ) {

        this.set( 'isCurrentPage', pageNumber === this.get('pageNumber') );

    }


});







/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/pageHierarchy/PageResult.js
 ** module id = 669
 ** module chunks = 0
 **/